import { c as _c } from "react/compiler-runtime";
import { AppLayout } from '@src/components/sco/AppLayout';
import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext';
import { PitchBuilderForms } from '@src/components/sco/InvestorMatching/InvestorMatchPitchBuilder/PitchBuilderForms';
import { PitchBuilderPreview } from '@src/components/sco/InvestorMatching/InvestorMatchPitchBuilder/PitchBuilderPreview';
import { useWindow } from '@src/hooks/useWindow';
import { gql } from '@src/lib/gql';
import { useParams } from 'next/navigation';
import React from 'react';
type InvestorMatchPitchBuilderProps = {
  investorSearchId?: string;
};
export const PITCH_BUILDER_INVESTOR_SEARCH_FRAGMENT = gql`
  fragment _ on ScoInvestorSearch {
    id
    investorSearchId
    companyElevatorPitch
    companyName
    companyWebsiteUrl
    emailTemplateAttachmentUrl
    emailTemplateFrom
    emailTemplateGeneratedBody
    emailTemplatePrompt
    emailTemplateSignature
    emailTemplateSignature
    emailTemplateSubject
    financialsStatement
    fundingGoalInDollars
    fundingGoalStageKey
    fundingGoalStatement
    fundingGoalStructureKeys
    location
    locationCity
    locationCountryKey
    locationLatitude
    locationLongitude
    locationState
    marketSizeStatement
    pitchDeckUrl
    problemStatement
    solutionStatement
    teamStatement
    tractionStatement
    relevantInvestorTags
    requiredInvestorTags
    searchingCompany {
      id
      companyId
      name
      elevatorPitch
    }
  }
`;
export const InvestorMatchPitchBuilder: React.FC<InvestorMatchPitchBuilderProps> = props => {
  const $ = _c(18);
  const params = useParams();
  const investorMatchLayout = useParentAppLayout();
  const window = useWindow();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      paddingX: 0,
      marginX: 0,
      boxShadow: "none",
      gap: 0
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      background: "colorPalette.container/50"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `${props.investorSearchId || params.investorSearchId}`;
  let t3;
  if ($[2] !== investorMatchLayout || $[3] !== t2) {
    t3 = {
      id: "pitch-builder-form",
      containerProps: t1,
      children: <PitchBuilderForms investorMatchAppLayout={investorMatchLayout} investorSearchId={t2} />
    };
    $[2] = investorMatchLayout;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      base: true,
      lg: false
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== window) {
    t5 = () => window.innerWidth ? window.innerWidth / 2 : 400;
    $[6] = window;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      background: "colorPalette.container"
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = `${props.investorSearchId || params.investorSearchId}`;
  let t8;
  if ($[9] !== investorMatchLayout || $[10] !== t7) {
    t8 = <PitchBuilderPreview investorMatchAppLayout={investorMatchLayout} investorSearchId={t7} />;
    $[9] = investorMatchLayout;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t5 || $[13] !== t8) {
    t9 = {
      id: "pitch-builder-preview",
      useDrawerBreakpoints: t4,
      resizeHandlePosition: "left",
      defaultWidth: t5,
      containerProps: t6,
      children: t8
    };
    $[12] = t5;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t3 || $[16] !== t9) {
    t10 = <AppLayout id="investor-matching-pitch-builder" scrollable={false} panelProps={t0} panels={[t3, t9]} />;
    $[15] = t3;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};